import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PAGE_ROUTES } from '../config/pageRoutes';

export default function DocumentTitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGE_ROUTES.find((item) => item.path === pathname);
    document.title = `${page?.title || '页面不存在'} | AI 大师兄`;
  }, [pathname]);
  return null;
}
